import React, { Component } from 'react';

// Import from Style
import {
  Wrapper,
  Link,
} from './style';

import AppState from '../../states/AppState';
import TrendingSearchState from '../../states/TrendingSearchState';

class TrendingSearchTerm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entering: true,
      exiting: false,
      opacity: 0,
      ticks: 0,
      exitAfter: (Math.random() * 200) + 100,
    };
  }
  componentDidMount() {
    this.animate();
  }

  animate = () => {
    if (this.state.ticks >= this.state.exitAfter) {
      this.setState({ entering: false, exiting: true });
    }

    let { entering, exiting, opacity } = this.state;
    const ticks = this.state.ticks + 1;
    let willBeDestroyed = false;

    if (this.state.entering) {
      opacity = this.state.opacity + 0.07;
      if (opacity >= 1) {
        entering = false;
        opacity = 1;
      }
    } else if (this.state.exiting) {
      opacity = this.state.opacity - 0.07;
      if (opacity <= 0) {
        exiting = false;
        opacity = 0;
        willBeDestroyed = true;
      }
    }

    this.setState({
      entering,
      exiting,
      opacity,
      ticks,
    });

    if (willBeDestroyed) {
      cancelAnimationFrame(this.animate);
      setTimeout(() => TrendingSearchState.destroyItem(this.props.item), 100);
    } else {
      requestAnimationFrame(this.animate);
    }
  }

  render() {
    const { item } = this.props;

    return (
      <Wrapper
        style={{
          opacity: this.state.opacity,
          left: item.position.x * TrendingSearchState.width,
          top: item.position.y * TrendingSearchState.height,
        }}
      >
        <Link
          href={item.term.url}
          target="_blank"
          rel="noopener noreferrer"
        >{item.term.label}</Link>
      </Wrapper>
    );
  }
}

export default TrendingSearchTerm;



// WEBPACK FOOTER //
// ./src/components/TrendingSearchTerm/index.js